var gql = require("@apollo/client").gql;

const PROVIDER_CARD_INFO_QUERY = gql`
	query Provider($filter: String, $filterNews: String!, $filterActions: String!) {
		provider(filter: $filter) {
			id
			name
			url_name
			logo
			logo_2
			logo_preview
			vip_provider
			update_date
			order_types {
				id
				name
			}
			info {
				cnt_tariffs
				cnt_reviews
				cnt_action_tariffs
				min_price
				max_price
			}
			reviews_info {
				count_total
			}
			rating {
				expert {
					final
				}
				rating_avg
				rating_min
				rating_max
				order_types {
					order_type_id
					rating
					rating_plus
					rating_minus
					rating_middle
					review_kind
					review_all
					provider_answer_count
					in_main_rating
					position
				}
			}
			specifications {
				idSpec: id
				name
				image
				value
				description
			}
			contacts {
				site
				site_href_view
				city
				street
				requisites
				phones
				phone_support
				home_office
				email
				blog
				name_legal
				link
				card
			}
			provider_settings {
				tariffs {
					value
					button_text
				}
				brand_button {
					mode
					btn_text
					btn_link
					btn_bg_color
					btn_text_color
				}
			}
			texts {
				about_self
				about_we
			}
			dody {
				name
				image
				image3
				full_description
			}
			sell_self {
				provider {
					name
					logo
					id
					url_name
					logo_preview
					region {
						url
					}
				}
			}
			region {
				id
				name
				url
			}
			global {
				id
				name
			}
			filters {
				speed {
					min
					max
					key
				}
				price {
					min
					max
					key
				}
				districts {
					id
					name
				}
				types {
					key
					name
					count
				}
			}
		}
		news: news(limit: 1, offset: 0, filter: $filterNews) {
			data {
				id
			}
		}
		actions: news(limit: 1, offset: 0, filter: $filterActions) {
			data {
				id
			}
		}
	}
`;

export default PROVIDER_CARD_INFO_QUERY;
